var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$tc("Template", 1) + " *",
            value: _vm.templateId,
            size: "medium",
            inputType: "other"
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              value: _vm.templateId,
              options: _vm.templateOptions,
              "load-options": _vm.loadTemplateOptions,
              normalizer: _vm.normalizer,
              disabled: _vm.disabled,
              disableFuzzyMatching: ""
            },
            on: { input: _vm.updateTemplateID }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input-field", {
        attrs: { label: "", value: "", size: "small", inputType: "other" }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$tc("Owner", 1),
          value: _vm.owner.selected,
          size: "small",
          inputType: "text",
          "field-disabled": true
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$tc("Layer", 2),
          value: _vm.possibleLayers.names,
          size: "small",
          inputType: "text",
          "field-disabled": true
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input-field",
          staticStyle: {
            "justify-content": "flex-end",
            height: "53px",
            "margin-top": "8px"
          }
        },
        [
          _c("v-checkbox", {
            staticClass: "multi-selection-checkbox",
            attrs: {
              color: "accent",
              ripple: false,
              disabled: false,
              label: _vm.$t("OnlyUsedElements")
            },
            on: {
              click: function($event) {
                return _vm.$emit("update-only-used-elements", _vm.usedByNetwork)
              }
            },
            model: {
              value: _vm.usedByNetwork,
              callback: function($$v) {
                _vm.usedByNetwork = $$v
              },
              expression: "usedByNetwork"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60f90383", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f90383","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationForm/TemplateTab.vue
// module id = null
// module chunks = 